export class RqInputDocumentAdditionalInformation {

    key: string
    type: string
    value: string

    constructor(key: string, type: string, value: string) {
        this.key = key
        this.type = type;
        this.value = value;
    }
}